/* eslint-disable react-hooks/exhaustive-deps */
import { Route, Routes } from "react-router-dom"
// import Home from "../../features/dashborad/pages/home";
// import  { CreateReportLogged } from "../../features/dashborad/pages/create-report";
// import SimpleCase from "../../features/dashborad/pages/create-survey";
import ListReportsPage from "../../features/dashborad/pages/list_reports";
// import ListSurveysPage from "../../features/dashborad/pages/list_surveys";
// import MyProfile from "../../features/dashborad/pages/my-profile";
import UsersClient from "../../features/dashborad/pages/users";
import ClientsAdm from "../../features/dashborad/pages/clients-adm"
// import Home from "./pages/home";
// import PurchasedProductsPage from "./pages/purchased_products";

// import UserWalletValuesCard from "./components/wallet_values";

const Dashboard = () => {
  

  return (
    <>
     {/* <HeaderDash/> */}
      <Routes>
        <Route path="/" element={<ListReportsPage />} />
        {/* <Route path="/home" element={<Home />} /> */}
        {/* <Route path="/create-report" element={<CreateReportLogged />} /> */}
        {/* <Route path="/create-survey" element={<SimpleCase isLogged={true} />} /> */}
        {/* <Route path="/reports" element={<ListReportsPage />} /> */}
        {/* <Route path="/surveys" element={<ListSurveysPage />} /> */}
        {/* <Route path="/profile" element={<MyProfile />} /> */}
        <Route path="/users/:clientId" element={<UsersClient />} />
        <Route path="/clients-adm" element={<ClientsAdm />} />
        {/* <Route path="/minhas-compras" element={<PurchasedProductsPage />} /> */}
      </Routes>
      {/* <UserWalletValuesCard /> */}
    </>
  );
};

export default Dashboard;
